import cx from 'classnames';
import styles from './ConditionalTile.module.scss';

type OwnProps = {
  backgroundButton?: any;
  goToPage?: any;
  isButtonCapitalized?: any;
  isMobile?: boolean;
  light?: boolean;
  primaryButton?: any;
  text?: any;
  visible?: boolean;
};

export default function CTButton({
  backgroundButton,
  goToPage,
  isButtonCapitalized,
  isMobile = false,
  light = false,
  primaryButton,
  text,
  visible = true
}: OwnProps) {
  const getMobileText = () => {
    const lowerCase = text.toLowerCase();

    return lowerCase.replace(lowerCase[0], text[0]);
  };

  return (
    <button
      onClick={goToPage}
      className={cx(
        styles.ctButton,
        'bg-transparent border h-40 rounded text-center tl-label-m w-[272px]',
        visible ? 'inline-block' : 'hidden',
        isButtonCapitalized ? 'capitalize' : 'uppercase',
        {
          light,
          mobile: isMobile,
          'btn-primary-ghost': primaryButton,
          'btn-background-ghost': backgroundButton
        }
      )}
      data-analytics-id="conditional-tile-revamp-button"
      type="button"
    >
      {isMobile ? getMobileText() : text}
    </button>
  );
}
